import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {ManufacturingCategoryState, Store} from './store';

@Injectable({ providedIn: 'root' })
export class ManufacturingCategoryQuery extends QueryEntity<ManufacturingCategoryState> {

  constructor(protected store: Store) {
    super(store);
  }

}
